export default __webpack_public_path__ + "static/media/ledgreen.4439d038.png";